var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7976 5.53111L13.2753 3.00883L10.6174 5.66675L13.8196 8.86888V12.8573L10.3186 10.836L10.0839 9.96004L10.0767 9.96197L9.15028 6.5044L5.5195 7.47726L6.44595 10.9348L3.00045 11.858L3.97331 15.4888L8.34751 14.3168L11.8375 16.3317L8.34832 18.3462L3.97286 17.1738L3 20.8045L6.4455 21.7278L5.51905 25.1853L9.14983 26.1582L10.0763 22.7006L10.0835 22.7025L10.3178 21.8279L13.8196 19.8061V23.7935L10.6165 26.9966L13.2744 29.6545L15.7967 27.1322L18.3278 29.6633L20.9857 27.0054L18.4546 24.4743L18.4599 24.4691L17.8196 23.8288V19.7855L21.2726 21.7791L22.445 26.1545L26.0758 25.1817L25.1526 21.7362L28.6102 20.8097L27.6373 17.179L24.1797 18.1054L24.1778 18.0982L23.3031 18.3326L19.8375 16.3317L23.3024 14.3312L24.1783 14.5659L24.1802 14.5588L27.6378 15.4852L28.6106 11.8544L25.1531 10.928L26.0763 7.48249L22.4455 6.50962L21.2735 10.8838L17.8196 12.8779V8.83551L18.4608 8.19428L18.4555 8.18903L20.9867 5.65792L18.3287 3L15.7976 5.53111Z",
    fill: "url(#paint0_linear_887_4804)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4804",
    x1: 19.8047,
    y1: 3,
    x2: 8.47135,
    y2: 26.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.65
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.826ed83b45f6af2d4b1cceba880acf05.svg";
export { ForwardRef as ReactComponent };